import { Mole } from 'state/vvsgotchi/models'
import { Text, FlexProps } from 'vvs-uikit'
import HealthIconImage from 'views/VvsGotchi/components/HealthIconImage'
import { MoleAvatar } from '../styles'
import { MoleMiniCardWrapper, CardRow, CardLabel } from './styles'

export const MoleMiniCard: React.FC<{ mole: Mole } & FlexProps> = ({ mole, ...props }) => {
  const { imageUrl, health } = mole

  return (
    <MoleMiniCardWrapper {...props}>
      <CardRow>
        <MoleAvatar image={imageUrl} />
      </CardRow>
      <CardLabel py={1} px={2}>
        {typeof health === 'number' && <HealthIconImage health={health} size="16px" />}
        <Text fontSize="13px" color="darkestNightBlue" bold>
          {health}
        </Text>
      </CardLabel>
    </MoleMiniCardWrapper>
  )
}

export default MoleMiniCard
